// extracted by mini-css-extract-plugin
export var text = "_79-0";